import { autoCapitalize } from '@conexasaude/front-utils/formatters'

export const autoCapitalizeName = (
  name: string,
  ignoreWords: string[] = [],
) => {
  if (typeof name !== 'string' || !name) return ''
  return autoCapitalize(name, {
    ignoreWords: [...ignoreWords, 'de', 'da', 'do', 'dos', 'das'],
  })
}
